<template>
    <div class="homepage d-flex flex-column vh-100">
        <!-- navbar -->
        <div class="d-flex align-items-center gap-3 p-3 bg-primary">
            <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span>
            <div>
                <h6 class="fw-bold text-white mb-0">Go Back</h6>
                <!--<p class="text-white-50 small m-0">To Home</p>-->
            </div>
        </div>
        <!--start------------------------------------------------------- body----------------------------------------------------------------------------->
        <div v-if="page1">

            <div class="card-header text-center mt-4">
                <h3>Select Categories</h3>
                <p>Add You Post In Bellow Any Category</p>
            </div>

            <div class="card border-0 shadow-sm p-4 bg-white rounded-4">
                <div class="card-body">
                    <div class="row ">
                        <div class="col-6 mt-2" v-for="(cat, i) in categories" :key="i">
                            <!-- Single Category -->
                            <label @click="show_form(cat.name)"
                                class="card border-0 shadow-sm p-3 d-flex align-items-center flex-row custon-design fw-bold m-0"
                                :for="'category-' + i">
                                <div class="card bg-transparent border-0 text-center">
                                    <img :src="'https://mh13.dktsoft.in/public/uploads/'+cat.img" alt=""
                                        class="card-img-top rounded-4 mb-2">
                                    <div class="card-body p-0">
                                        <!--<p class="card-title small m-0">{{cat.name}}</p>-->
                                    </div>
                                </div>

                                <div>

                                    <input name="category" type="radio" :id="'category-' + i" :value="cat.name"
                                        v-model="selectedCategory" class="me-2" style="display:none" />
                                    <!--{{ cat.name }}-->

                                </div>
                            </label>

                        </div>
                    </div>

                </div>
                <!-- <button type="submit" class="btn btn-primary w-100 custom-btn" @click="newregister">Save</button> -->
            </div>
        </div>
        <div v-if="page2">

            <div class="card-header text-center mt-4">
                <h3>Please Fill Bellow Details</h3>
            </div>

            <div class="card border-0 shadow-sm p-2 bg-white rounded-4">
                <div class="card-body">
                    <div v-if="isEvent">
                        <h5 class="card-title text-center">Event Form</h5>
                        <div class="mb-1">
                            <label for="name" class="form-label">Name</label>
                            <input type="text" id="name" v-model="event.name" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">Slug</label>
                            <input type="text" id="slug" readonly="" v-model="event.slug" class="form-control" placeholder="Type Here" required>
                        </div>


                        <div class="mb-1">
                            <label for="img" class="form-label">Event Category</label>
                            <select class="form-control" v-model="event.cat_id">

                                <option value="" disabled>--SELECT category--</option>
                                <option v-for="cat in eventcategories" :key="event.cat_id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>


                        <div class="mb-1">
                            <label for="description" class="form-label">Description</label>
                            <textarea id="description" v-model="event.description" class="form-control"placeholder="Type Here"
                                required></textarea>
                        </div>
                        <div class="mb-1">
                            <label for="contact" class="form-label">Contact</label>
                            <input type="number" id="contact" v-model="event.contact" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="website" class="form-label">Website</label>
                            <input type="text" id="website" v-model="event.website" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div class="mb-1">
                            <label for="time" class="form-label">Date/Time</label>
                            <input type="datetime-local" id="time" v-model="event.time" class="form-control" placeholder="Type Here" required>
                        </div>


                        <div class="mb-1">
                            <label for="fromdate" class="form-label">From Date</label>
                            <input type="date" id='fromdate' v-model="event.fromdate" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div class="mb-1">
                            <label for="todate" class="form-label">To Date</label>
                            <input type="date" id='todate' v-model="event.todate" class="form-control" placeholder="Type Here" required>
                        </div>





                        <div class="mb-1">
                            <label for="cost" class="form-label">Cost</label>
                            <input type="number" id="cost" v-model="event.cost" class="form-control"placeholder="Type Here"  required>
                        </div>
                        
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>

                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>


                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="event.latitude" readonly="" placeholder="Type Here"class="form-control"
                                required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="event.longitude" readonly="" placeholder="Type Here"class="form-control"
                                required>
                        </div>
                        <div class="mb-1">
                            <label for="location" class="form-label">Address</label>
                            <input type="text" id="location" v-model="event.location" class="form-control" required>
                        </div>

                        <label for="img">Select Image<br>
                            <input type="file" id="img" @change="eventFileUpload"  accept="image/*" hidden>
                            <i class="bi bi-file-earmark-arrow-up-fill"
                                style="font-size: 50px; width: 50px; height: 50px;"></i>
                        </label>
                        <img v-if="event_imageUrl" :src="event_imageUrl" alt="Preview" width="200">



                        <img v-if="isEvent && event.img"
                            :src="'https://mh13.dktsoft.in/public/uploads/event/' + event.img" alt="img"
                            class="img-fluid mt-2" width="150" height="150">


                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="submit" class="btn btn-danger w-100  " @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100 " @click="save_event">Save</button>
                            </div>
                        </div>


                    </div>

                    <div v-if="isFood">
                        <div class="mb-1">
                            <div class="card-title text-center">Food Form</div>
                            <label for="name" class="form-label">Name Of Shop</label>
                            <input type="text" id="name" v-model="food.name" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">Slug</label>
                            <input type="text" id="slug" readonly="" v-model="food.slug" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="description" class="form-label">Description</label>
                            <textarea id="description" v-model="food.description" class="form-control" rows="3" placeholder="Type Here" required></textarea>
                        </div>                        
                        <div class="mb-1">
                            <label for="mobile" class="form-label">Mobile Number</label>
                            <input type="number" id="name" v-model="food.mobile" class="form-control" placeholder="Type Here" required>
                        </div>
                 


                        
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>
                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>

                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="food.latitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="food.longitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        
                        <div class="mb-1">
                            <label for="location" class="form-label">Address</label>
                            <input type="text" id="location" v-model="food.location" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div>
                            <label for="img">Select Image<br>
                                <input type="file" id="img" @change="handleFileUpload"  accept="image/*" hidden>
                                <i class="bi bi-file-earmark-arrow-up-fill"
                                    style="font-size: 50px; width: 50px; height: 50px;"></i>
                            </label>
                            <img v-if="imageUrl" :src="imageUrl" alt="Preview" width="200">
                        </div>

                        <!-- Display Image Dynamically -->
                        <img v-if="isFood && food.img" :src="'https://mh13.dktsoft.in/public/uploads/food/' + food.img"
                            alt="img" class="img-fluid mt-2" width="150" height="150">


                        <div class="mb-1">
                            <label for="img" class="form-label">Food Category</label>
                            <select class="form-control" v-model="food.cat_id">

                                <option value="" disabled>--SELECT category--</option>
                                <option v-for="cat in foodcategories" :key="food.cat_id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>

                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="submit" class="btn btn-danger w-100" @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100" @click="save_food">Save</button>
                            </div>
                        </div>

                    </div>
                    <div v-if="isNews">
                        <div class="mb-1">
                            <div class="card-title text-center">News Form</div>
                            <label for="name" class="form-label">Heading Of News</label>
                            <input type="text" id="name" v-model="news.name" class="form-control"placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">Slug</label>
                            <input type="text" id="slug" readonly="" v-model="news.slug" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="description" class="form-label">Description</label>
                            <textarea id="name" v-model="news.description" class="form-control" placeholder="Type Here" required></textarea>
                        </div>
                    
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>
                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>
                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="news.latitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="news.longitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="location" class="form-label">Location</label>
                            <input type="text" id="location" v-model="news.location" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div>
                            <label for="img">Select Image<br>
                                <input type="file" id="img" @change="newsFileUpload" accept="image/*" hidden>
                                <i class="bi bi-file-earmark-arrow-up-fill"
                                    style="font-size: 50px; width: 50px; height: 50px;"></i>
                            </label>
                            <img v-if="newsimageUrl" :src="newsimageUrl" alt="Preview" width="200">
                        </div>


                        <!-- <div class="mb-1">
                            <label for="img" class="form-label">Image</label>
                            <input type="file" id="img" @change="newsFileUpload" class="form-control" required>
                        </div> -->




                        <img v-if="isNews && news.img" :src="'https://mh13.dktsoft.in/public/uploads/news/' + news.img"
                            alt="img" class="img-fluid mt-2" width="150" height="150">
                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="submit" class="btn btn-danger w-100" @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100" @click="save_news">Save</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isBusiness">
                        <div class="card-title text-center">Business Form</div>
                        <div class="mb-1">
                            <label for="name" class="form-label">Business Name</label>
                            <input type="text" id="name" v-model="business.name" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">slug</label>
                            <input type="text" id="slug" readonly="" v-model="business.slug" placeholder="Type Here" class="form-control"
                                required>
                        </div>
                        <div class="mb-1">
                            <label for="description" class="form-label">Description</label>
                            <textarea id="description" v-model="business.description" placeholder="Type Here" class="form-control"
                                required></textarea>
                        </div>
                        <div class="mb-1">
                            <label for="offer" class="form-label">Offer</label>
                            <input type="text" id="offer" v-model="business.offer" placeholder="Type Here" class="form-control" required>
                        </div>
                        <div class="mb-1">
                            <label for="website" class="form-label">Website</label>
                            <input type="text" id="website" v-model="business.website" placeholder="Type Here" class="form-control" required>
                        </div>

                        <div class="mb-1">
                            <label for="mobile" class="form-label">Mobile Number</label>
                            <input type="number" id="mobile" v-model="business.mobile" max="10" class="form-control"placeholder="Type Here"
                                required>
                        </div>
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>
                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>

                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="business.latitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="business.longitude" readonly="" class="form-control"placeholder="Type Here"
                                required>
                        </div>
                        <div class="mb-1">
                            <label for="location" class="form-label">Address</label>
                            <input type="text" id="location" v-model="business.location"  class="form-control"placeholder="Type Here"
                                required>
                        </div>


                        <div>
                            <label for="img">Select Image<br>
                                <input type="file" id="img" @change="businessFileUpload"  accept="image/*" hidden>
                                <i class="bi bi-file-earmark-arrow-up-fill"
                                    style="font-size: 50px; width: 50px; height: 50px;"></i>
                            </label>
                            <img v-if="businessimageUrl" :src="businessimageUrl" alt="Preview" width="200">
                        </div>


                        <img v-if="isBusiness && business.img"
                            :src="'https://mh13.dktsoft.in/public/uploads/business/' + business.img" alt="img"
                            class="img-fluid mt-2" width="150" height="150">

                        <div class="mb-1">
                            <label for="img" class="form-label">Business Category</label>
                            <select class="form-control" v-model="business.cat_id">

                                <option value="" disabled>--SELECT category--</option>
                                <option v-for="cat in businesscategories" :key="business.cat_id" :value="cat.id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>

                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="submit" class="btn btn-danger w-100" @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100" @click="save_business">Save</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isProperties">
                        <div class="card-title text-center">Property Form</div>
                        <div class="mb-1">
                            <label for="name" class="form-label">Property Heading</label>
                            <input type="text" id="name" v-model="property.name" class="form-control" placeholder="ex. 2BHK At Jule Solapur " required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">slug</label>
                            <input type="text" id="slug" readonly="" v-model="property.slug" class="form-control" placeholder="Type Here"
                                required>
                        </div>
                        <div class="mb-1">
                            <label for="website" class="form-label">Contact</label>
                            <input type="number" id="website" v-model="property.contact" max="10" class="form-control" placeholder="Type Here"
                                required>
                        </div>

                        <div class="mb-1">
                            <label for="description" class="form-label">Description</label>
                            <textarea id="description" v-model="property.description" class="form-control" placeholder="Type Here"
                                required></textarea>
                        </div>
                        <div class="mb-1">
                            <label for="offer" class="form-label">Offer</label>
                            <input type="text" id="offer" v-model="property.offer" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="website" class="form-label">Website</label>
                            <input type="text" id="website" v-model="property.website" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="cost" class="form-label">Cost</label>
                            <input type="number" id="cost" v-model="property.cost" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1">
                            <label for="feet" class="form-label">Area sq.feet</label>
                            <input type="text" id="feet" v-model="property.feet" class="form-control" placeholder="Type Here" required>
                        </div>
                        
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>
                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>

                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="property.latitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>
                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="property.longitude"readonly=""  class="form-control" placeholder="Type Here"
                                required>
                        </div>

                        <div class="mb-1">
                            <label for="location" class="form-label">Address</label>
                            <input type="text" id="location" v-model="property.location" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div>
                            <label for="img">Select Image<br>
                                <input type="file" id="img" @change="propertyFileUpload" accept="image/*" hidden>
                                <i class="bi bi-file-earmark-arrow-up-fill"
                                    style="font-size: 50px; width: 50px; height: 50px;"></i>
                            </label>
                            <img v-if="propertyimageUrl" :src="propertyimageUrl" alt="Preview" width="200">
                        </div>

                        <img v-if="isProperties && property.img"
                            :src="'https://mh13.dktsoft.in/public/uploads/property/' + property.img" alt="img"
                            class="img-fluid mt-2" width="150" height="150">

                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="submit" class="btn btn-danger w-100" @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100" @click="save_property">Save</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="isJob">
                        <div class="card-title text-center">Job Form</div>

                        <div class="mb-1">
                            <label for="title" class="form-label">Job Title</label>
                            <input type="text" id="title" v-model="job.title" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div class="mb-1" style="display:none">
                            <label for="slug" class="form-label">Slug</label>
                            <input type="text" id="slug" readonly="" v-model="job.slug" class="form-control" placeholder="Slug" required>
                        </div>

                        <div class="mb-1">
                            <label for="jobtype" class="form-label">Job Type</label>
                            <input type="text" id="jobtype" v-model="job.jobtype" class="form-control" placeholder="Healthcare/It/Finance" required>
                        </div>

                        <div class="mb-1">
                            <label for="jobtype" class="form-label">Job Description</label>
                            <textarea id="jobtype" v-model="job.description" class="form-control" placeholder="Type Here" required></textarea>
                        </div>

                        <div class="mb-1">
                            <label for="companyname" class="form-label">Company Name</label>
                            <input type="text" id="companyname" v-model="job.companyname" placeholder="Type Here" class="form-control" required>
                        </div>

                        <div class="mb-1">
                            <label for="educationreq" class="form-label">Education Requirement</label>
                            <input type="text" id="educationreq" v-model="job.educationreq" class="form-control" placeholder="Type Here"
                                required>
                        </div>

                        <div class="mb-1">
                            <label for="jobexperience" class="form-label">Job Experience</label>
                            <input type="text" id="jobexperience" v-model="job.jobexperience" class="form-control" placeholder="Type Here"
                                required>
                        </div>

                        <div class="mb-1">
                            <label for="experienceyear" class="form-label">Experience (Years)</label>
                            <input type="number" id="experienceyear" v-model="job.experienceyear" class="form-control" placeholder="Type Here"
                                required>
                        </div>

                        <div class="mb-1">
                            <label for="contact" class="form-label">Contact</label>
                            <input type="number" id="contact" v-model="job.contact" max="10" class="form-control" placeholder="Type Here"
                                required>
                        </div>


                        <div class="mb-1">
                            <label for="website" class="form-label">Website</label>
                            <input type="text" id="website" v-model="job.website" class="form-control" placeholder="Type Here" required>
                        </div>
                        
                        <div class="p-2">
                        <small class="text-danger fw-bold">{{error?error:'Click On Map To Place Location'}}</small><button style="float:right;" @click="getCurrentLocation" class="btn btn-primary p-1"><i class="bi bi-location"></i>Get Location</button>
                        </div>

                        <GMapMap :center="center" :zoom="12" style="width: 100%; height: 250px" @click="selectLocation">
                            <GMapMarker :position="selectedLocation" v-if="selectedLocation" />
                        </GMapMap>

                        <div class="mb-1" style="display:none">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" id="latitude" v-model="job.latitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>

                        <div class="mb-1" style="display:none">
                            <label for="longitude" class="form-label">Longitude</label>
                            <input type="text" id="longitude" v-model="job.longitude" readonly="" class="form-control" placeholder="Type Here" required>
                        </div>


                        <div class="mb-1">
                            <label for="joblocation" class="form-label">Job Address</label>
                            <input type="text" id="joblocation" v-model="job.joblocation" class="form-control"  placeholder="Type Here" required>
                        </div>


                        <div>
                            <label for="img">Select Image<br>
                                <input type="file" id="img" @change="jobFileUpload" accept="image/*" hidden>
                                <i class="bi bi-file-earmark-arrow-up-fill"
                                    style="font-size: 50px; width: 50px; height: 50px;"></i>
                            </label>
                            <img v-if="jobimageUrl" :src="jobimageUrl" alt="Preview" width="200">
                        </div>

                        <img v-if="isJob && job.img" :src="'https://mh13.dktsoft.in/public/uploads/jobs/' + job.img"
                            alt="img" class="img-fluid mt-2" width="150" height="150">

                        <div class="row mt-4">
                            <div class="col-6">
                                <button type="button" class="btn btn-danger w-100" @click="goBack">Previous</button>
                            </div>
                            <div class="col-6">
                                <button type="submit" class="btn btn-success w-100" @click="saveJob">Save</button>
                            </div>
                        </div>
                    </div>



                </div>

            </div>
        </div>




        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->












        <!-- footer -->
        <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>

    </div>
</template>

<style scoped>
    .hover-zoom {
        transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    }

    .hover-zoom:hover {
        transform: scale(1.05);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    }

    .custon-design {
        text-transform: capitalize;
        background-color: bisque;
    }

    .custom-btn {
        background: linear-gradient(328deg, #ff0000, #000199);
        border: none;
        /* Remove Bootstrap's default border */
        color: white;
        /* Ensure text is readable */
    }

    .form-control {
        border: 1px solid;
    }

    .form-label {
        margin-bottom: 0px;
        font-weight: 500;
    }
</style>



<script>
    import axios from "@/plugins/axios";
    import { ref, watch } from "vue";
    export default {

        setup() {
            const getCurrentLocation = () => {
              if (!navigator.geolocation) {
                console.error("Geolocation is not supported by your browser.");
                return;
              }
            
              navigator.geolocation.getCurrentPosition(
                async (position) => {
                  const lat = position.coords.latitude;
                  const lng = position.coords.longitude;
            
                  selectedLocation.value = { lat, lng };
                  center.value = { lat, lng }; // Optional: re-center the map
                  await getAddress(lat, lng); // Optional: fetch address
                },
                (error) => {
                  console.error("Geolocation error:", error.message);
                },
                {
                  enableHighAccuracy: true,
                  timeout: 10000,
                  maximumAge: 0,
                }
              );
            };

            const center = ref({ lat: 17.6599, lng: 75.9064 }); // Default to Solapur
            const selectedLocation = ref(null);
            let self = this;
            const address = ref("");
            const selectLocation = async (eventData) => {
                const lat = eventData.latLng.lat();
                const lng = eventData.latLng.lng();

                selectedLocation.value = { lat, lng };

                // Fetch address using Google Geocoding API
                await getAddress(lat, lng);
            };

            const getAddress = async (lat, lng) => {
                const apiKey = "AIzaSyD9gtJ2oDY7AcqUPTjmER1Ki0ZYC4mbIe0"; // Replace with your API Key
                const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

                try {
                    const response = await fetch(url);
                    const data = await response.json();
                    if (data.status === "OK" && data.results.length > 0) {
                        address.value = data.results[0].formatted_address;
                    } else {
                        address.value = "Address not found";
                    }
                } catch (error) {
                    console.error("Geocoding API error:", error);
                    address.value = "Error fetching address";
                }
                 
            };
            return {
                center,
                selectedLocation,
                selectLocation,
                address,
                getCurrentLocation,
            };
        },
        name: 'HomeView',
        components: {
        },
        mounted() {

            if (this.$route.query.name && this.$route.query.id) {
                this.getBasicEdit(this.$route.query.name, this.$route.query.id);
            }
            else {
                this.getHomeBasic();
            } // Call the method here

        },
        data() {
            return {
                location:[],
                imageUrl: null,
                event_imageUrl :null,
                businessimageUrl:null,
                newsimageUrl:null,
                propertyimageUrl:null,
                jobimageUrl:null,
                loading: false,
                error: null,
                isEdit: false,
                categories: [],
                foodcategories: [],
                businesscategories: [],
                eventcategories:[],
                page1: true,
                page2: false,
                page3: false,
                isEvent: false,
                isNews: false,
                isFood: false,
                isBusiness: false,
                isProperties: false,
                isJob: false,
                food: {
                    name: '',
                    slug: '',
                    mobile: '',
                    location: '',
                    description: '',
                    latitude: '',
                    longitude: '',
                    file: '',
                    cat_id: '',
                },
                event: {
                    name: '',
                    slug: '',
                    description: '',
                    location: '',
                    time: '',
                    cost: '',
                    location: '',
                    latitude: '',
                    longitude: '',
                    website: '',
                    cat_id: '',
                    fromdate:'',
                    todate:''
                },
                news: {
                    name: '',
                    slug: '',
                    description: '',
                    location: '',
                    latitude: '',
                    longitude: '',
                    file: ''
                },
                business: {
                    name: '',
                    slug: '',
                    description: '',
                    contact: '',
                    website: '',
                    offer: '',
                    mobile: '',
                    latitude: '',
                    longitude: '',
                    location:'',
                    cat_id: ''
                },
                property: {
                    name: '',
                    slug: '',
                    contact: '',
                    description: '',
                    offer: '',
                    website: '',
                    cost: '',
                    feet: '',
                    location: '',
                    latitude: '',
                    longitude: '',
                    file: ''
                },
                job: {
                    title: '',
                    slug: '',
                    jobtype: '',
                    description: '',
                    companyname: '',
                    educationreq: '',
                    jobexperience: '',
                    experienceyear: '',
                    contact: '',
                    joblocation: '',
                    website: '',
                    latitude: '',
                    longitude: '',
                    file: '',
                }


            }
        },
        watch: {
            selectedLocation(newValue) {
                if (this.isEvent) {
                    this.event.latitude = newValue.lat;
                    this.event.longitude = newValue.lng;
                } else if (this.isFood) {
                    this.food.latitude = newValue.lat;
                    this.food.longitude = newValue.lng;
                }
                else if (this.isNews) {
                    this.news.latitude = newValue.lat;
                    this.news.longitude = newValue.lng;
                } else if (this.isBusiness) {
                    this.business.latitude = newValue.lat;
                    this.business.longitude = newValue.lng;
                } else if (this.isProperties) {
                    this.property.latitude = newValue.lat;
                    this.property.longitude = newValue.lng;
                } else if (this.isJob) {
                    this.job.latitude = newValue.lat;
                    this.job.longitude = newValue.lng;
                }
            },
            address(newValue) {
                
                if (this.isEvent) {
                    this.event.location = newValue;;
                }
                if (this.isFood) {
                    this.food.location = newValue;;
                }
                if (this.isBusiness) {
                    this.business.location = newValue;;
                }
                if (this.isJob) {
                    this.job.joblocation = newValue;;
                }
                if (this.isProperties) {
                    this.property.location = newValue;;
                }
                if (this.isNews) {
                    this.news.location = newValue;;
                }
            },
            'food.name'(newValue) {
                this.food.slug = this.generateSlug(newValue);
            },

            'event.name'(newValue) {
                this.event.slug = this.generateSlug(newValue);
            },

            'news.name'(newValue) {
                this.news.slug = this.generateSlug(newValue);
            },

            'business.name'(newValue) {
                this.business.slug = this.generateSlug(newValue);
            },
            'property.name'(newValue) {
                this.property.slug = this.generateSlug(newValue);
            },

            'job.title'(newValue) {
                this.job.slug = this.generateSlug(newValue);
            }


        },
        methods: {
            goBack() {

                if (this.isEdit) {
                    this.$router.push('/profile');
                } else {
                    if (this.page1)
                        this.$router.go(-1);
                    else if (this.page2) {
                        this.page1 = true;
                        this.page2 = false;
                        this.page3 = false;
                    }
                }
            },



            generateSlug(value) {
                return (value ?? '')
                    .toString()
                    .normalize("NFD") // Normalize to handle special characters
                    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9\s]/g, '') // Remove special characters except spaces
                    .replace(/\s+/g, '-') // Replace spaces with '-'
                    .replace(/-+/g, '-'); // Remove duplicate '-'
            },



            initializeHomeContent() {
            },
            handleFileUpload(event) {
                this.food.file = event.target.files[0]; // Store the selected file
                this.imageUrl = URL.createObjectURL(event.target.files[0]);
            },
            eventFileUpload(event) {
                this.event.file = event.target.files[0]; // Store the selected file
                this.event_imageUrl = URL.createObjectURL(event.target.files[0]);
            },
            newsFileUpload(event) {
                this.news.file = event.target.files[0]; // Store the selected file
                this.newsimageUrl = URL.createObjectURL(event.target.files[0]);
            },
            businessFileUpload(event) {
                this.business.file = event.target.files[0]; // Store the selected file
                this.businessimageUrl = URL.createObjectURL(event.target.files[0]);
            },
            propertyFileUpload(event) {
                this.property.file = event.target.files[0]; // Store the selected file
                this.propertyimageUrl = URL.createObjectURL(event.target.files[0]);
            },
            jobFileUpload(event) {
                this.job.file = event.target.files[0]; // Store the selected file
                this.jobimageUrl = URL.createObjectURL(event.target.files[0]);
            },


            newregister() {

                alert("hello")


            },
            previous_food() {
                this.isFood = false;
            },



            async getHomeBasic() {
                this.loading = true;
                this.error = null;

                try {
                    var self = this;
                    axios.post("getfrontview").then((response) => {
                        self.isEdit = false;
                        self.categories = response.data.app_categories;
                        self.foodcategories = response.data.foodcategories;
                        self.eventcategories = response.data.eventcategories;
                        self.businesscategories = response.data.businesscategories;
                        self.events = response.data.events;
                        self.listings = response.data.businesslisting;
                        self.properties = response.data.properties;
                        self.isUserLogged = response.data.isUserLogged;


                    }).then(() => {
                        self.initializeHomeContent();
                    }).catch((err) => {

                    });;


                } catch (err) {
                    this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                    this.loading = false;
                }
            },



            async getBasicEdit(name = "", id = "") {
                this.loading = true;
                this.error = null;

                try {
                    var self = this;
                    axios.post("getfrontedit", { _name: name, _id: id }).then((response) => {
                        self.isEdit = true;
                        self.page1 = false;
                        self.page2 = true;
                        self.page3 = false;

                        self.isEvent = false;
                        self.isNews = false;
                        self.isFood = false;
                        self.isBusiness = false;
                        self.isProperties = false;
                        self.isJob = false;

                        if (response.data.selected_type == "food") {
                            self.isFood = true;
                            self.food = response.data.food;
                            self.foodcategories = response.data.foodcategories;
                        } else if (response.data.selected_type == "event") {
                            self.isEvent = true;
                            self.event = response.data.events;

                        } else if (response.data.selected_type == "news") {
                            self.isNews = true;
                            self.news = response.data.news;

                        } else if (response.data.selected_type == "business") {
                            self.isBusiness = true;
                            self.business = response.data.business;
                            self.businesscategories = response.data.businesscategories;
                        }
                        else if (response.data.selected_type == "properties") {
                            self.isProperties = true;
                            self.job = response.data.job;
                        } else if (response.data.selected_type == "job") {
                            self.isJob = true;
                            self.job = response.data.job;
                        }
                        self.isUserLogged = response.data.isUserLogged;


                    }).then(() => {
                        self.initializeHomeContent();
                    }).catch((err) => {

                    });;


                } catch (err) {
                    this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                    this.loading = false;
                }
            },













            show_form(category_name) {
                this.page1 = false;
                this.page2 = false;
                this.page3 = false;
                this.isEvent = false;
                this.isNews = false;
                this.isFood = false;
                this.isBusiness = false;
                this.isProperties = false;
                this.isJob = false;


                this.page2 = true;
                if (category_name == "event") {
                    this.isEvent = true;
                } else if (category_name == "business") {
                    this.isBusiness = true;
                } else if (category_name == "food") {
                    this.isFood = true;
                } else if (category_name == "news") {
                    this.isNews = true;
                } else if (category_name == "property") {
                    this.isProperties = true;
                }
                else if (category_name == "job") {
                    this.isJob = true;
                }

            },


            save_food() {

                try {
                    var self = this;
                    if (self.food.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.food.location === "") {
                        self.$swal("Enter location");
                    } else if (self.food.mobile === "" || self.food.mobile < 10) {
                        self.$swal("Enter Mobile");
                    } else if (self.food.description === "") {
                        self.$swal("Enter Description");
                    } else if (self.food.latitude === "") {
                        self.$swal("Enter latitude");
                    } else if (self.food.longitude === "") {
                        self.$swal("Enter longitude");
                    }
                    else {
                        axios.post("savefood", self.food, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },



            save_event() {

                try {
                    var self = this;
                    if (self.event.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.event.description === "") {
                        self.$swal("Enter description");
                    } else if (self.event.contact === "" || self.event.contact < 10) {
                        self.$swal("Enter Mobile");
                    } else if (self.event.location === "") {
                        self.$swal("Enter location");
                    } else if (self.event.time === "") {
                        self.$swal("Enter time");
                    } else if (self.event.cost === "") {
                        self.$swal("Enter cost");
                    } else if (self.event.location === "") {
                        self.$swal("Enter location");
                    } else if (self.event.latitude === "") {
                        self.$swal("Enter latitude");
                    } else if (self.event.longitude === "") {
                        self.$swal("Enter longitude");
                    } else if (self.event.website === "") {
                        self.$swal("Enter website");
                    }
                    else if (self.event.fromdate === "") {
                        self.$swal("Enter Fromdate");
                    }
                    else if (self.event.todate === "") {
                        self.$swal("Enter Todate");
                    }

                    else {
                        axios.post("saveevent", self.event, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },


            save_news() {

                try {
                    var self = this;
                    if (self.news.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.news.description === "") {
                        self.$swal("Enter description");
                    } else if (self.news.location === "") {
                        self.$swal("Enter location");
                    } else if (self.news.latitude === "") {
                        self.$swal("Enter latitude");
                    } else if (self.news.longitude === "") {
                        self.$swal("Enter Longitude");
                    }
                    else {
                        axios.post("savenews", self.news, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },


            save_business() {

                try {
                    var self = this;
                    if (self.business.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.business.slug === "") {
                        self.$swal("Enter Slug");
                    } else if (self.business.description === "") {
                        self.$swal("Enter Description");
                    } else if (self.business.website === "") {
                        self.$swal("Enter Website");
                    } else if (self.business.offer === "") {
                        self.$swal("Enter Offer");
                    } else if (self.business.mobile === "" || self.business.mobile < 10) {
                        self.$swal("Enter Mobile");
                    } else if (self.business.latitude === "") {
                        self.$swal("Enter Latitude");
                    }  else if (self.business.location === "") {
                        self.$swal("Enter Location");
                    }else if (self.business.longitude === "") {
                        self.$swal("Enter Longitude");
                    }
                    else {
                        axios.post("savebusiness", self.business, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },








            save_property() {

                try {
                    var self = this;
                    if (self.property.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.property.slug === "") {
                        self.$swal("Enter Slug");
                    } else if (self.property.contact === "" || self.property.contact < 10) {
                        self.$swal("Enter Contact");
                    } else if (self.property.description === "") {
                        self.$swal("Enter Description");
                    } else if (self.property.offer === "") {
                        self.$swal("Enter Offer");
                    } else if (self.property.website === "") {
                        self.$swal("Enter Website");
                    } else if (self.property.cost === "") {
                        self.$swal("Enter Cost");
                    } else if (self.property.feet === "") {
                        self.$swal("Enter Feet");
                    } else if (self.property.location === "") {
                        self.$swal("Enter Location");
                    } else if (self.property.latitude === "") {
                        self.$swal("Enter Latitude");
                    } else if (self.property.longitude === "") {
                        self.$swal("Enter Longitude");
                    }

                    else {
                        axios.post("saveproperty", self.property, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },




            saveJob() {

                try {
                    var self = this;
                    if (self.job.name === "") {
                        self.$swal("Enter Name");
                    } else if (self.job.slug === "") {
                        self.$swal("Enter Slug");
                    } else if (self.job.jobtype === "") {
                        self.$swal("Enter Job Type");
                    } else if (self.job.description === "") {
                        self.$swal("Enter Job Description");
                    } else if (self.job.companyname === "") {
                        self.$swal("Enter Company Name");
                    } else if (self.job.educationreq === "") {
                        self.$swal("Enter Education Requirement");
                    } else if (self.job.jobexperience === "") {
                        self.$swal("Enter Job Experience");
                    } else if (self.job.experienceyear === "") {
                        self.$swal("Enter Experience Year");
                    } else if (self.job.contact === "" || self.job.contact < 10) {
                        self.$swal("Enter Contact");
                    } else if (self.job.joblocation === "") {
                        self.$swal("Enter Job Location");
                    } else if (self.job.website === "") {
                        self.$swal("Enter Website");
                    } else if (self.job.latitude === "") {
                        self.$swal("Enter Latitude");
                    } else if (self.job.longitude === "") {
                        self.$swal("Enter Longitude");
                    }
                    else {
                        axios.post("savejob", self.job, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((response) => {

                            if (response.data.success == 1) {
                                self.$swal(response.data.message);
                            }

                        }).then(() => {


                        });;

                    }



                } catch (err) {

                }


            },
             













        }
    }





</script>